
import ActionButton from '@/components/ActionButton.vue'
import WorkspaceDropdown from '@/components/WorkspaceDropdown.vue'
import Avatar from '@/components/Avatar.vue'
import WorkspaceList from '@/components/WorkspaceList.vue'
import WorkspaceListItem from '@/components/WorkspaceListItem.vue'
import { defineComponent } from '@vue/runtime-core'
import { inviteMemberService, searchMemberService } from '@/services/board'
import { MemberType } from '@/types/entities'
export default defineComponent({
  components: {
    ActionButton,
    WorkspaceDropdown,
    WorkspaceList,
    WorkspaceListItem,
    Avatar
  },
  data () {
    return {
      search: '',
      chosenMembers: [],
      searchedMembers: [],
      inviteDD: false,
      disabledSendInvite: true,
      searchTimeout: null
    }
  },
  methods: {
    debouncedSearch () {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.handleSearch()
        clearTimeout(this.searchTimeout)
      }, 300)
    },
    async handleSearch () {
      if (!this.search.length) return
      const res = await searchMemberService(this.$route.params.boardId, this.search)
      if (!res.error) {
        this.searchedMembers = res.data
      }
    },
    async handleSendInvitation () {
      this.disabledSendInvite = true
      const res = await inviteMemberService(
        this.$route.params.boardId,
        this.chosenMembers.map((mem: MemberType) => mem.email)
      )
      if (!res.error) {
        this.search = ''
        this.chosenMembers = []
        this.inviteDD = false
      }
    },
    handleChooseMember (payload: MemberType) {
      this.searchedMembers = this.searchedMembers.filter((i: MemberType) => i.email !== payload.email)
      if (this.chosenMembers.findIndex((cm: MemberType) => cm.email === payload.email) === -1) {
        this.chosenMembers.push(payload)
        this.disabledSendInvite = false
      }
    },
    handleRemoveChosen (payload: MemberType) {
      this.chosenMembers = this.chosenMembers.filter((cm: MemberType) => cm.email !== payload.email)
      if (this.searchedMembers.findIndex((cm: MemberType) => cm.email === payload.email) === -1) {
        this.searchedMembers.push(payload)
      }
    }
  }
})
